/* eslint-disable max-len */
import { LanguagesType } from 'shared/locale'

const notifications: Record<LanguagesType, Record<string, string>> = {
  'en-US': {
    btc: `
    <div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY Bitcoin (BTC)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, BEP20, ERC20, SegWit or other network standards, you may lose your money </br></br>
    <span style="color: #1CBDF7">Choose ONLY the Bitcoin network (BTC) to fund your account </span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
    usdttrc20: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY Tether (USDT)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, OMNI, SOL or other network standards, you may lose your money</br></br>
    <span style="color: #1CBDF7">Choose ONLY the Tron network (TRC20) to fund your account</span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    <br/><br/>
    </div>`,
    eth: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY Ethereum (ETH)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, BEP20 or other network standards, you may lose your money</br></br>
    <span style="color: #1CBDF7">Choose ONLY the Ethereum network (ETH) to fund your account </span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
    usdterc20: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY Tether (USDT)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, BEP20, TRC20, OMNI, SOL and other network standards, you may lose your money </br></br>
    <span style="color: #1CBDF7">Choose ONLY the Ethereum network (ERC20) to fund your account </span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
    bnbbsc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY BNB</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, ERC20 or other network standards, you may lose your money</br></br>
    <span style="color: #1CBDF7">Choose ONLY the BNB Smart Chain network (BEP20) to fund your account</span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
    busdbsc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY BNB (BUSD)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, ERC20 or other network standards, you may lose your money </br></br>
    <span style="color: #1CBDF7">Choose ONLY the BNB Smart Chain network (BEP20) to fund your account </span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
    doge: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY Dogecoin (DOGE)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, BEP20 or other network standards, you may lose your money </br></br>
    <span style="color: #1CBDF7">Choose ONLY the Dogecoin network (DOGE) to fund your account </span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
    trx: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY Tron (TRX)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, BEP20, ERC20 or other network standards, you may lose your money</br></br>
    <span style="color: #1CBDF7">Choose ONLY the Tron network (TRX) to fund your account </span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
    ltc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Send ONLY Litecoin (LTC)</span> to this deposit address</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, BEP20, ERC20 or other network standards, you may lose your money</br></br>
    <span style="color: #1CBDF7">Choose ONLY the Litecoin network (LTC) to fund your account </span></br></br>
    Other contract addresses <span style="color: #1CBDF7">are not allowed</span></br></br>
    By clicking the "Continue" button, you indicate that you <span style="color: #1CBDF7">agree to the above-mentioned risks </span>
    </div>`,
  },
  
  'ar-ar': {
    btc: `
    <div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط Bitcoin (BTC)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو BEP20 أو ERC20 أو SegWit أو غيرها من معايير الشبكة، فقد تفقد أموالك </br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة Bitcoin (BTC) لتمويل حسابك </span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
    usdttrc20: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط Tether (USDT)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو OMNI أو SOL أو غيرها من معايير الشبكة، فقد تفقد أموالك</br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة Tron (TRC20) لتمويل حسابك</span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    <br/><br/>
    </div>`,
    eth: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط Ethereum (ETH)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو BEP20 أو غيرها من معايير الشبكة، فقد تفقد أموالك</br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة Ethereum (ETH) لتمويل حسابك </span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
    usdterc20: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط Tether (USDT)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو BEP20 أو TRC20 أو OMNI أو SOL وغيرها من معايير الشبكة، فقد تفقد أموالك </br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة Ethereum (ERC20) لتمويل حسابك </span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
    bnbbsc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط BNB</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو ERC20 أو غيرها من معايير الشبكة، فقد تفقد أموالك</br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة BNB Smart Chain (BEP20) لتمويل حسابك</span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
    busdbsc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط BNB (BUSD)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو ERC20 أو غيرها من معايير الشبكة، فقد تفقد أموالك </br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة BNB Smart Chain (BEP20) لتمويل حسابك </span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
    doge: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط Dogecoin (DOGE)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو BEP20 أو غيرها من معايير الشبكة، فقد تفقد أموالك </br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة Dogecoin (DOGE) لتمويل حسابك </span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
    trx: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط Tron (TRX)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو BEP20 أو ERC20 أو غيرها من معايير الشبكة، فقد تفقد أموالك</br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة Tron (TRX) لتمويل حسابك </span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
    ltc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    أرسل فقط Litecoin (LTC)</span> إلى عنوان الإيداع هذا</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو BEP20 أو ERC20 أو غيرها من معايير الشبكة، فقد تفقد أموالك</br></br>
    <span style="color: #1CBDF7">اختر فقط شبكة Litecoin (LTC) لتمويل حسابك </span></br></br>
    عناوين العقود الأخرى <span style="color: #1CBDF7">غير مسموح بها</span></br></br>
    بالنقر على زر «متابعة»، فإنك تؤكد <span style="color: #1CBDF7">موافقتك على المخاطر المذكورة أعلاه </span>
    </div>`,
  },
  'fr-fr': {
    btc: `
    <div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT Bitcoin (BTC)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, BEP20, ERC20, SegWit ou d'autres normes de réseau, vous pourriez perdre votre argent </br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau Bitcoin (BTC) pour approvisionner votre compte </span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
    usdttrc20: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT Tether (USDT)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, OMNI, SOL ou d'autres normes de réseau, vous pourriez perdre votre argent</br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau Tron (TRC20) pour approvisionner votre compte</span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    <br/><br/>
    </div>`,
    eth: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT Ethereum (ETH)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, BEP20 ou d'autres normes de réseau, vous pourriez perdre votre argent</br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau Ethereum (ETH) pour approvisionner votre compte </span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
    usdterc20: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT Tether (USDT)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, BEP20, TRC20, OMNI, SOL ou d'autres normes de réseau, vous pourriez perdre votre argent </br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau Ethereum (ERC20) pour approvisionner votre compte </span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
    bnbbsc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT BNB</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, ERC20 ou d'autres normes de réseau, vous pourriez perdre votre argent</br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau BNB Smart Chain (BEP20) pour approvisionner votre compte</span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
    busdbsc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT BNB (BUSD)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, ERC20 ou d'autres normes de réseau, vous pourriez perdre votre argent </br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau BNB Smart Chain (BEP20) pour approvisionner votre compte </span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
    doge: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT Dogecoin (DOGE)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, BEP20 ou d'autres normes de réseau, vous pourriez perdre votre argent </br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau Dogecoin (DOGE) pour approvisionner votre compte </span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
    trx: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT Tron (TRX)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, BEP20, ERC20 ou d'autres normes de réseau, vous pourriez perdre votre argent</br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau Tron (TRX) pour approvisionner votre compte </span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
    ltc: `<div style="font-size: 1.1rem"><span style="color: #1CBDF7">
    Envoyez UNIQUEMENT Litecoin (LTC)</span> à cette adresse de dépôt</br></br>
    <span style="color: #1CBDF7">N'UTILISEZ PAS</span>
    BEP2, BEP20, ERC20 ou d'autres normes de réseau, vous pourriez perdre votre argent</br></br>
    <span style="color: #1CBDF7">Choisissez UNIQUEMENT le réseau Litecoin (LTC) pour approvisionner votre compte </span></br></br>
    Les autres adresses de contrat <span style="color: #1CBDF7">ne sont pas autorisées</span></br></br>
    En cliquant sur le bouton "Continuer", vous indiquez que vous <span style="color: #1CBDF7">acceptez les risques mentionnés ci-dessus </span>
    </div>`,
  },
}

const withdrawNotifications: Record<LanguagesType, Record<string, string>> = {
  'en-US': {
    usdttrc20: `<div style="font-size: 1.1rem">Please send<span style="color: #1CBDF7">
    ONLY the Tron network (TRC20)</span> to withdraw your funds</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, OMNI, SOL or other network standards, you may lose your money</br></br>
    </div>`,
  },
  'fr-fr': {
    usdttrc20: `<div style="font-size: 1.1rem">Please send<span style="color: #1CBDF7">
    ONLY the Tron network (TRC20)</span> to withdraw your funds</br></br>
    <span style="color: #1CBDF7">DO NOT use</span>
    BEP2, OMNI, SOL or other network standards, you may lose your money</br></br>
    </div>`,
  },
  'ar-ar': {
    usdttrc20: `<div style="font-size: 1.1rem">يُرجى استخدام<span style="color: #1CBDF7">
    شبكة Tron فقط (TRC20)</span> لسحب أموالك</br></br>
    <span style="color: #1CBDF7">لا تستخدم</span>
    BEP2 أو OMNI أو SOL أو غيرها من معايير الشبكة، فقد تفقد أموالك</br></br>
    </div>`,
  },
}

export const getCryptoPaymentNotification = (lang: LanguagesType, paymentSystem: string) => ({
  __html: (notifications[lang] ?? notifications['en-US'])?.[paymentSystem] ?? '',
})

export const getCryptoWithdrawNotification = (lang: LanguagesType, paymentSystem: string) => ({
  __html: (withdrawNotifications[lang] ?? withdrawNotifications['en-US'])?.[paymentSystem] ?? '',
})
